// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/change-password`
  | `/change-password/failure`
  | `/change-password/success`
  | `/reset-password`
  | `/reset-password/confirm-email`
  | `/reset-password/failure`
  | `/reset-password/new`
  | `/reset-password/success`
  | `/signin`
  | `/signin/callback`
  | `/user`

export type Params = {
  
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
